import { FoodWelcomeSVG } from "./SVGIllustrations";
import { PillSelect } from "@/components/we360/PillSelect";
import { FREQ_DIET, FOOD_ITEMS } from "./helpers";

const ITEMS_1 = FOOD_ITEMS.slice(0, 5);

export default function Step1Consumption1({ answers, onChange, errors }) {
  return (
    <div>
      <FoodWelcomeSVG />

      <div
        className="rounded-[14px] p-3 mt-3 mb-4 text-xs leading-relaxed"
        style={{ background: "#FCFAEE", border: "1px solid #E2D9CB", color: "#2D2A24" }}
        data-testid="f4-intro-text"
      >
        Responde pensando en una <strong>semana normal</strong>. Con que frecuencia consumes estos alimentos?
      </div>

      {ITEMS_1.map((item) => (
        <div key={item.id} className="mb-4">
          <div className="flex items-center gap-2 mb-1">
            <span className="text-xs font-semibold" style={{ color: "#2D2A24" }}>{item.label}</span>
            {item.inverse && (
              <span
                className="text-[9px] font-bold px-2 py-0.5 rounded-lg shrink-0"
                style={{ background: "#FFF3DC", color: "#F9A01B" }}
                data-testid={`f4-tag-${item.id}`}
              >
                a limitar
              </span>
            )}
          </div>
          <PillSelect
            options={FREQ_DIET.map((f) => f)}
            value={answers[item.id] ?? ""}
            onChange={(v) => onChange(item.id, v)}
            error={errors?.getError(`food_${item.id}`)}
            testId={`f4-food-${item.id}`}
            columns={1}
          />
        </div>
      ))}
    </div>
  );
}
